import { render } from "./ForceAlertPopup.vue?vue&type=template&id=f4b4fc64&scoped=true"
import script from "./ForceAlertPopup.vue?vue&type=script&lang=js"
export * from "./ForceAlertPopup.vue?vue&type=script&lang=js"

import "./ForceAlertPopup.vue?vue&type=style&index=0&id=f4b4fc64&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b4fc64"]])

export default __exports__